import { render } from "./ClaimTypePicker.vue?vue&type=template&id=38080046"
import script from "./ClaimTypePicker.vue?vue&type=script&lang=js"
export * from "./ClaimTypePicker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__